class Analytics {
  constructor() {
    this.gtag = null;
    this.isProduction = true; // window.location.href.includes('valueguideproweb.npauctions.com');
    this.debug = true;
  }

    initialize = () => {
        console.log('gtag init')
      window.dataLayer = window.dataLayer || [];
      // function gtag(){dataLayer.push(arguments);}

      this.gtag = function gtag() {
        if (this.isProduction) {
          window.dataLayer.push(arguments);
          return;
        }
        if (this.debug) {
          console.log('--GA DEBUG--');
          console.log(arguments);
        }
      };

      this.gtag('js', new Date());

      this.gtag('config', 'G-NPGWG1TYVK');

    };

    RecordEvent = (event, category, label, value) => {
      this.gtag('event', event, {
        event_category: category,
        event_label: label,
        value,
      });
    };

    RecordPageView = (path, title) => {
      this.gtag({
        event: 'pageview',
        page: {
          path,
          title,
        },
      });
      console.log('pageview', this.gtag);
    };
}

export default new Analytics();
